import { useEffect } from "react";
import Navbar from "../../components/admin/Navbar.tsx";
import { Outlet } from "react-router-dom";
import OptionAgent from "../../components/admin/agentAdmin/OptionAgent.tsx";


const LayoutAgentAdmin = () => {
    useEffect(() => {
        document.body.classList.add("admin-body");
        return () => {
            document.body.classList.remove("admin-body");
        };
    }, []);

    return (
        <>
            <Navbar />
            <div className="custom-container-admin grow admin-shell">
                <div>
                    <div className="col-12">
                        <OptionAgent />
                    </div>
                      <div className='col-md-12 '>
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    );
}
export default LayoutAgentAdmin;
